import { render, staticRenderFns } from "./TarjetaResultadoDoctor.vue?vue&type=template&id=29776bf8"
import script from "./TarjetaResultadoDoctor.vue?vue&type=script&lang=js"
export * from "./TarjetaResultadoDoctor.vue?vue&type=script&lang=js"
import style0 from "./TarjetaResultadoDoctor.vue?vue&type=style&index=0&id=29776bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports